// extracted by mini-css-extract-plugin
module.exports = {"culture":"club_culture__u6vxB"};